<template>
  <div class="weui-container" ref="container" role="dialog" tabindex="-1" aria-modal="true">
    <div class="weui-mask"></div>
    <div class="weui-dialog" :class="[{ 'weui-dialog-hastitle': finalTitle }]">
      <div class="weui-dialog__hd" v-if="finalTitle">
        <strong class="weui-dialog__title">{{ finalTitle }}</strong>
      </div>
      <div
        class="weui-dialog__bd"
        :class="[align ? `weui-dialog__bd__${align}` : '']"
        v-if="finalContent || htmlContent || $slots.default"
      >
        <div v-if="htmlContent" v-html="htmlContent"></div>
        <span v-else>{{ finalContent }}</span>
        <slot></slot>
      </div>
      <div class="weui-dialog__ft" :class="[btnAlignStyle]">
        <a
          href="javascript:;"
          v-for="(item, index) in btns"
          :class="['weui-dialog__btn', getBtnType(index), item.class]"
          :key="index"
          @click="handleClick(index)"
        >{{item.text}}</a>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Prop, Component, Vue, Ref } from 'vue-property-decorator';
import { DialogButtonItem } from '../type';

@Component
export default class FitDialog extends Vue {
  @Prop({ default: '' })title!: string;
  @Prop({ default: '' })content!: string;
  @Prop({ default: '' })htmlContent!: string;
  @Prop({ default: '' })align!: string;
  @Prop({ default: () => ([]) })btns!: DialogButtonItem[];
  /** 是否挂载到body中 */
  @Prop({ default: false }) isAppendToBody!: boolean;
  /** 是否可以滚动 */
  @Prop({ default: false })scrollable!: boolean;
  @Ref('container') container!: HTMLDivElement;

  mounted() {
    // 禁止弹窗时，页面滑动
    // 需注意，若弹窗内有滚动条，同样会禁止了弹窗内的文案滚动。
    if (!this.scrollable) {
      this.container.addEventListener('touchmove', (e) => {
        e.preventDefault();
      });
    }

    if (this.isAppendToBody) {
      document.body.appendChild(this.$el);
    }
  }

  destroyed() {
    if (this.isAppendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }

  get finalTitle() {
    if (this.title && (!this.content && !this.htmlContent)) {
      // 如果有标题 但是没有内容 则展示标题
      return '';
    }
    return this.title;
  }

  get isAlign() {
    return this.btns.length >= 3;
  }

  get btnAlignStyle() {
    return this.isAlign ? 'weui-dialog__ft__vertical' : '';
  }

  get finalContent() {
    if (this.title && (!this.content && !this.htmlContent)) {
      // 如果有标题 但是没有内容 则展示标题
      return this.title;
    }
    return this.content || this.htmlContent;
  }

  getBtnType(index) {
    if (this.isAlign) {
      return index < this.btns.length - 1 ? 'weui-dialog__btn_primary' : 'weui-dialog__btn_default';
    }
    return index === this.btns.length - 1 ? 'weui-dialog__btn_primary' : 'weui-dialog__btn_default';
  }

  handleClick(index: number) {
    if (typeof this.btns[index].click === 'function') {
      this.btns[index].click?.();
    } else {
      this.$emit('click');
    }
  }
}

</script>
